import { RouteRecordRaw } from 'vue-router';

const rotasAplicacao: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'Aplicacao',
    component: () => import(/* webpackChunkName: "core" */ '@/core/layout/SubLayout.vue'),
    children: [
      {
        path: 'sem-privilegio',
        name: 'SemPrivilegio',
        meta: {
          titulo: 'Você não possui autorização!',
          identificadorPermissao: '',
        },
        component: () => import(/* webpackChunkName: "core" */ '@/core/views/SemPrivilegio.vue'),
      },
      {
        path: '',
        name: 'Dashboard',
        meta: {
          titulo: 'Dashboard',
          identificadorPermissao: 'DASHBOARD',
        },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: 'configuracoes',
        name: 'Configuracoes',
        meta: {
          titulo: 'Configurações',
          identificadorPermissao: 'CONFIGURACOES',
        },
        component: () => import(/* webpackChunkName: "configuracoes" */ '@/views/Configuracoes.vue'),
      },
      {
        path: 'configuracoes-emails',
        name: 'ConfiguracoesEmails',
        meta: {
          titulo: 'Configurações de E-mails',
          identificadorPermissao: 'CONFIGURACOES',
        },
        component: () => import(/* webpackChunkName: "configuracoes" */ '@/views/ConfiguracoesEmails.vue'),
      },
      {
        path: 'meu-negocio',
        name: 'MeuNegocio',
        meta: {
          titulo: 'Meu Negócio',
          identificadorPermissao: 'MEU_NEGOCIO',
        },
        component: () => import(/* webpackChunkName: "configuracoes" */ '@/views/MeuNegocio.vue'),
      },
      {
        path: 'usuarios',
        name: 'Usuarios',
        meta: {
          titulo: 'Usuários',
          identificadorPermissao: 'USUARIOS',
        },
        component: () => import(/* webpackChunkName: "usuarios" */ '@/views/Usuarios/UsuarioListagem.vue'),
      },
      {
        path: 'usuarios/cadastrar',
        name: 'UsuarioCadastroCriar',
        meta: {
          titulo: 'Cadastrar Usuário',
          identificadorPermissao: 'USUARIOS',
        },
        component: () => import(/* webpackChunkName: "usuarios" */ '@/views/Usuarios/UsuarioCadastro.vue'),
      },
      {
        path: 'usuarios/:codigo',
        name: 'UsuarioCadastroEditar',
        meta: {
          titulo: 'Editar Usuário',
          identificadorPermissao: 'USUARIOS',
        },
        component: () => import(/* webpackChunkName: "categorias" */ '@/views/Usuarios/UsuarioCadastro.vue'),
      },
      {
        path: 'usuarios/meus-dados',
        name: 'UsuarioMeusDados',
        meta: {
          titulo: 'Meus Dados',
          identificadorPermissao: '',
        },
        component: () => import(/* webpackChunkName: "usuarios" */ '@/views/Usuarios/MeusDados.vue'),
      },
      {
        path: 'pessoas',
        name: 'Pessoas',
        meta: {
          titulo: 'Pessoas',
          identificadorPermissao: 'CADASTROS',
        },
        component: () => import(/* webpackChunkName: "pessoas" */ '@/views/Pessoas/PessoaListagem.vue'),
      },
      {
        path: 'pessoas/cadastrar',
        name: 'PessoaCadastroCriar',
        meta: {
          titulo: 'Cadastrar Pessoa',
          identificadorPermissao: 'CADASTROS',
        },
        component: () => import(/* webpackChunkName: "pessoas" */ '@/views/Pessoas/PessoaCadastro.vue'),
      },
      {
        path: 'pessoas/:codigo',
        name: 'PessoaCadastroEditar',
        meta: {
          titulo: 'Editar Pessoa',
          identificadorPermissao: 'CADASTROS',
        },
        component: () => import(/* webpackChunkName: "pessoas" */ '@/views/Pessoas/PessoaCadastro.vue'),
      },
      {
        path: 'prioridades',
        name: 'Prioridades',
        meta: {
          titulo: 'Prioridades',
          identificadorPermissao: 'PRIORIDADES',
        },
        component: () => import(/* webpackChunkName: "prioridades" */ '@/views/Prioridades/PrioridadeListagem.vue'),
      },
      {
        path: 'prioridades/cadastrar',
        name: 'PrioridadeCadastroCriar',
        meta: {
          titulo: 'Cadastrar Prioridade',
          identificadorPermissao: 'PRIORIDADES',
        },
        component: () => import(/* webpackChunkName: "prioridades" */ '@/views/Prioridades/PrioridadeCadastro.vue'),
      },
      {
        path: 'prioridades/:codigo',
        name: 'PrioridadeCadastroEditar',
        meta: {
          titulo: 'Editar Prioridade',
          identificadorPermissao: 'PRIORIDADES',
        },
        component: () => import(/* webpackChunkName: "prioridades" */ '@/views/Prioridades/PrioridadeCadastro.vue'),
      },
      {
        path: 'origens',
        name: 'Origens',
        meta: {
          titulo: 'Origens',
          identificadorPermissao: 'ORIGENS',
        },
        component: () => import(/* webpackChunkName: "origens" */ '@/views/Origens/OrigemListagem.vue'),
      },
      {
        path: 'origens/cadastrar',
        name: 'OrigemCadastroCriar',
        meta: {
          titulo: 'Cadastrar Origem',
          identificadorPermissao: 'ORIGENS',
        },
        component: () => import(/* webpackChunkName: "origens" */ '@/views/Origens/OrigemCadastro.vue'),
      },
      {
        path: 'origens/:codigo',
        name: 'OrigemCadastroEditar',
        meta: {
          titulo: 'Editar Origem',
          identificadorPermissao: 'ORIGENS',
        },
        component: () => import(/* webpackChunkName: "origens" */ '@/views/Origens/OrigemCadastro.vue'),
      },
      {
        path: 'leis-consideracoes',
        name: 'LeisConsideracoes',
        meta: {
          titulo: 'Leis e Considerações',
          identificadorPermissao: 'ORIGENS',
        },
        component: () => import(/* webpackChunkName: "leis-consideracoes" */ '@/views/LeisConsideracoes/LeiConsideracaoListagem.vue'),
      },
      {
        path: 'leis-consideracoes/cadastrar',
        name: 'LeiConsideracaoCadastroCriar',
        meta: {
          titulo: 'Cadastrar Lei Consideração',
          identificadorPermissao: 'ORIGENS',
        },
        component: () => import(/* webpackChunkName: "leis-consideracoes" */ '@/views/LeisConsideracoes/LeiConsideracaoCadastro.vue'),
      },
      {
        path: 'leis-consideracoes/:codigo',
        name: 'LeiConsideracaoCadastroEditar',
        meta: {
          titulo: 'Editar Lei Consideração',
          identificadorPermissao: 'ORIGENS',
        },
        component: () => import(/* webpackChunkName: "leis-consideracoes" */ '@/views/LeisConsideracoes/LeiConsideracaoCadastro.vue'),
      },
      {
        path: 'tipos',
        name: 'Tipos',
        meta: {
          titulo: 'Tipos',
          identificadorPermissao: 'TIPOS',
        },
        component: () => import(/* webpackChunkName: "tipos" */ '@/views/Tipos/TipoListagem.vue'),
      },
      {
        path: 'tipos/cadastrar',
        name: 'TipoCadastroCriar',
        meta: {
          titulo: 'Cadastrar Tipo',
          identificadorPermissao: 'TIPOS',
        },
        component: () => import(/* webpackChunkName: "tipos" */ '@/views/Tipos/TipoCadastro.vue'),
      },
      {
        path: 'tipos/:codigo',
        name: 'TipoCadastroEditar',
        meta: {
          titulo: 'Editar Tipo',
          identificadorPermissao: 'TIPOS',
        },
        component: () => import(/* webpackChunkName: "tipos" */ '@/views/Tipos/TipoCadastro.vue'),
      },
      {
        path: 'definicoes-ocorrencias',
        name: 'DefinicaoOcorrencias',
        meta: {
          titulo: 'Definições de Ocorrências',
          identificadorPermissao: 'DEFINICOES_OCORRENCIAS',
        },
        component: () => import(/* webpackChunkName: "definicoes-ocorrencias" */ '@/views/DefinicoesOcorrencias/DefinicaoOcorrenciaListagem.vue'),
      },
      {
        path: 'definicoes-ocorrencias/cadastrar',
        name: 'DefinicaoOcorrenciaCadastroCriar',
        meta: {
          titulo: 'Cadastrar Definição das Ocorrências',
          identificadorPermissao: 'DEFINICOES_OCORRENCIAS',
        },
        component: () => import(/* webpackChunkName: "definicoes-ocorrencias" */ '@/views/DefinicoesOcorrencias/DefinicaoOcorrenciaCadastro.vue'),
      },
      {
        path: 'definicoes-ocorrencias/:codigo',
        name: 'DefinicaoOcorrenciaCadastroEditar',
        meta: {
          titulo: 'Editar Definição das Ocorrências',
          identificadorPermissao: 'DEFINICOES_OCORRENCIAS',
        },
        component: () => import(/* webpackChunkName: "definicoes-ocorrencias" */ '@/views/DefinicoesOcorrencias/DefinicaoOcorrenciaCadastro.vue'),
      },
      {
        path: 'ocorrencias',
        name: 'Ocorrencias',
        meta: {
          titulo: 'Ocorrências',
          identificadorPermissao: 'OCORRENCIAS',
        },
        component: () => import(/* webpackChunkName: "ocorrencias" */ '@/views/Ocorrencias/OcorrenciaListagem.vue'),
      },
      {
        path: 'ocorrencias/nova',
        name: 'OcorrenciaCadastroCriar',
        meta: {
          titulo: 'Registro de Ocorrência',
          identificadorPermissao: 'OCORRENCIAS',
        },
        component: () => import(/* webpackChunkName: "ocorrencias" */ '@/views/Ocorrencias/OcorrenciaCadastro.vue'),
      },
      {
        path: 'ocorrencias/:codigo',
        name: 'OcorrenciaCadastroEditar',
        meta: {
          titulo: 'Editar Ocorrência',
          identificadorPermissao: 'OCORRENCIAS',
        },
        component: () => import(/* webpackChunkName: "ocorrencias" */ '@/views/Ocorrencias/OcorrenciaCadastro.vue'),
      },
      {
        path: 'oficios',
        name: 'Oficios',
        meta: {
          titulo: 'Ofícios',
          identificadorPermissao: 'OFICIOS',
        },
        component: () => import(/* webpackChunkName: "oficios" */ '@/views/Oficios/OficioListagem.vue'),
      },
      {
        path: 'oficios/novo',
        name: 'OficioCadastroCriar',
        meta: {
          titulo: 'Registro de Ofício',
          identificadorPermissao: 'OFICIOS',
        },
        component: () => import(/* webpackChunkName: "oficios" */ '@/views/Oficios/OficioCadastro.vue'),
      },
      {
        path: 'oficios/:codigo',
        name: 'OficioCadastroEditar',
        meta: {
          titulo: 'Editar Ofício',
          identificadorPermissao: 'OFICIOS',
        },
        component: () => import(/* webpackChunkName: "oficios" */ '@/views/Oficios/OficioCadastro.vue'),
      },
    ],
  },
];

export default rotasAplicacao;
